import { useDispatch, useSelector } from 'react-redux';

// selectors
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';
import { useSingleTradeInFormProvider } from '../MultiTradeIn/TradeInFormProvider';

// libraries
import { kebabCase } from '@makemydeal/dr-common-utils';

// constants
import { TRANSMISSION, ZERO_WIDTH_SPACE } from '../../../constants';

// components
import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// styling
import { DetailContainer } from '../trade.style';

interface TransmissionFieldProps {
    hasTradeIn: boolean;
    isManualFormOpen: boolean;
    disabled?: boolean;
}

export const TransmissionField: React.FC<TransmissionFieldProps> = ({ hasTradeIn, isManualFormOpen, disabled }) => {
    const dispatch = useDispatch();
    const { tradeInIndex } = useSingleTradeInFormProvider();
    const transmission = useSelector(tradeInsSelectors.getTransmission(tradeInIndex));

    const onChange = (event: any) => {
        dispatch(tradeInsActionCreators.updateTradeInTransmission(event.target.value, tradeInIndex));
    };

    return (
        <>
            {isManualFormOpen ? (
                <TextInput
                    label={TRANSMISSION}
                    data-testid={kebabCase(TRANSMISSION)}
                    name={kebabCase(TRANSMISSION)}
                    onChange={onChange}
                    value={transmission}
                    disabled={disabled}
                    size="sm"
                    selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                />
            ) : (
                <>
                    {hasTradeIn && (
                        <DetailContainer>
                            <Typography variant="label-md" color="sem.color.on-surface.muted" sx={{ marginBottom: '8px' }}>
                                {TRANSMISSION}
                            </Typography>
                            <Typography variant="body-md" tag="span" data-testid="trade-transmission-value-label">
                                {transmission || ZERO_WIDTH_SPACE}
                            </Typography>
                        </DetailContainer>
                    )}
                </>
            )}
        </>
    );
};
